var isBeefCo = function isBeefCo(props) {
  return 'beefCo' in props;
};
export var defaultExtractPageDSL = function defaultExtractPageDSL(props) {
  return isBeefCo(props) ? {
    model: props.model,
    beefCo: props.beefCo
  } : {
    model: props,
    beefCo: null
  };
};